import { createApiRequest } from '../../store/api'

const getBuildingById = async ({ buildingId }) =>
  createApiRequest({ method: 'get', url: `/buildings/${buildingId}` })

export { getBuildingById }
